"use client";

import { useCallback, useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from 'next/navigation'

import Modal from "@/components/ProfilePage/component/Modal";
import { dayDiff } from "@/utils";

function PostModal() {
  const [modalOpen, setModalOpen] = useState(false);
  const pathname = usePathname();

  const modalWasShown = useCallback(() => {
    const modalState = JSON.parse(window.localStorage.getItem("blog-modal")) || {};

    if (Object.keys(modalState).includes(pathname)) {
      if (dayDiff(modalState[pathname]) < 1) {
        return true;
      }
    }

    window.localStorage.setItem("blog-modal", JSON.stringify({
      ...modalState,
      [pathname]: new Date().toISOString()
    }));

    return false;
  }, [pathname]);

  useEffect(() => {
    // Create an Intersection Observer
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        observer.unobserve(currentElement);
        if (!modalWasShown()) {
          setModalOpen(true);
        }
      }
    }, { threshold: 0.2 });

    // Observe the referenced element
    const currentElement = document?.querySelector(`[alt="Signup Now"]`);
    if (currentElement) {
      observer.observe(currentElement);
    }

    // Cleanup the observer when the component unmounts
    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, [modalWasShown]);

  useEffect(() => {
    document?.documentElement.style.setProperty("--color-layout-background", "#0f1123");
    document?.documentElement.style.setProperty("--color-background", "#0f1123");
    document?.documentElement.style.setProperty("--heading", "#ffffff");
    document?.documentElement.style.setProperty("--color-text", "#ffffff");
    document?.documentElement.style.setProperty("--color-primary", "#ffffff");
    document?.documentElement.style.setProperty("--color-secondary", "#0f1123");
  }, [pathname]);

  return (
    <Modal
      onClose={() => setModalOpen(false)}
      show={!!modalOpen}
      size="md"
      noBorder
      popup
    >
      <Link
        style={{
          marginBottom: -10
        }}
        href={`https://www.downfor.life/`}
        target="_blank"
        className="hover:underline"
        title="Signup to Downfor link"
      >
        <Image
          src={"https://www.downfor.life/img/visit-downfor.png"}
          priority={true}
          width={600}
          height={300}
          title="Signup to Downfor"
          alt="Signup to Downfor"
        />
      </Link>
    </Modal>
  );
}

export default PostModal;